import React from 'react';
import { FormBandeiras } from './formBandeira';
import { TableBandeiras } from './tableBandeira';

export const AbaBandeiras: React.FC = () => {
  return (
    <>
      <FormBandeiras />
      <TableBandeiras />
    </>
  );
};
